import { __makeTemplateObject } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';
import { DropdownItem } from '../../styles.js';

var LayoutItem = styled(DropdownItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 11px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 11px;\n"])));
var templateObject_1;

export { LayoutItem };
